// extracted by mini-css-extract-plugin
export default {"card":"PaymentFail_card__Kfo0J","icon":"PaymentFail_icon__lCBdm","info":"PaymentFail_info__rN7Oc"};